import { render, staticRenderFns } from "./upComingWfh.vue?vue&type=template&id=56ba088a&"
import script from "./upComingWfh.vue?vue&type=script&lang=js&"
export * from "./upComingWfh.vue?vue&type=script&lang=js&"
import style0 from "./upComingWfh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports